'use client'

import { SxProps } from '@mui/system'
import { useMattersStore } from '@repo/store/useMattersStore'
import { MatterDrawerMatterTab } from '@repo/ui/MatterDrawerMatterTab'
import { MatterDrawerClientExtensionsTab } from '@repo/ui/MatterDrawerClientExtensionsTab'
import { MatterDrawerClientTab } from '@repo/ui/MatterDrawerClientTab'
import { MatterDrawerRelatedMattersTab } from '@repo/ui/MatterDrawerRelatedMattersTab'
import { MatterDrawerMatterExtensionsTab } from '@repo/ui/MatterDrawerMatterExtensionsTab'
import { MatterWorkspaceActionsMenu } from '@repo/client-matter-workspaces/MatterWorkspaceActionsMenu'
import { MatterDrawerTopTabs } from '@repo/ui/MatterDrawerTopTabs'
import { PopupWithBackdrop } from '@repo/ui/PopupWithBackdrop'
import MUIAlert from '@mui/material/Alert'
import MUIAlertTitle from '@mui/material/AlertTitle'
import MUIPaper from '@mui/material/Stack'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'
import MUIStack from '@mui/material/Stack'
import { Link, useRouteLoaderData } from 'react-router-dom'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

export const WorkspaceDetailsCard = ({ isClientWorkspace, sx, test }: WorkspaceDetailsCardProps) => {
  const [workspaceDetailCardVisible, setWorkspaceDetailCardVisible] = useState<boolean>(false)
  const { currentMatter, matterDrawerConflicts, matterDrawerClientMatterNo, currentClientMatterNo } = useMattersStore()

  const isClientOnly =
    test === true && currentMatter.clientMatterNo && currentMatter.clientNo
      ? currentMatter.clientMatterNo === currentMatter.clientNo
      : false

  const [selectedTab, setSelectedTab] = useState(isClientOnly || isClientWorkspace ? 'client' : 'matter')

  const changeTab = (e: React.SyntheticEvent<Element, Event>, value: string) => {
    e.stopPropagation()
    setSelectedTab(value)
  }

  useEffect(() => {
    setWorkspaceDetailCardVisible(true)
  }, [workspaceDetailCardVisible, matterDrawerClientMatterNo, currentMatter])

  if (!currentMatter) return <MUIPaper data-testid="WorkspaceDetailsCard" />

  return (
    <MUIPaper
      data-testid="WorkspaceDetailsCard"
      sx={{
        width: '100%',
        height: 'auto',
        padding: '0',
        background: 'white',
        borderRadius: 1,
        boxShadow: 'none',
        border: '1px solid #D8DCE5',
        position: 'relative',
        ...sx
      }}
    >
      <MUIStack
        display={'flex'}
        direction="row"
        sx={{ alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}
      >
        <MUITypography sx={{ padding: '1rem' }} variant="h6">
          Details
        </MUITypography>

        <MatterWorkspaceActionsMenu workspace={isClientWorkspace ? 'client' : 'matter'} />
      </MUIStack>

      <MatterDrawerTopTabs
        selectedTab={selectedTab}
        isClientOnly={isClientOnly}
        isClientWorkspace={isClientWorkspace}
        onChange={changeTab}
      />

      <div style={{ height: '100%', overflowX: 'hidden' }}>
        {renderTabContent({ selectedTab, workspaceDetailCardVisible })}
      </div>
    </MUIPaper>
  )
}

const renderTabContent = ({ selectedTab, workspaceDetailCardVisible }: renderTabContentProps) => {
  switch (selectedTab) {
    case 'matter':
      return <MatterDrawerMatterTab workspaceDetailCardVisible={workspaceDetailCardVisible} />
    case 'matterExt':
      return <MatterDrawerMatterExtensionsTab workspaceDetailCardVisible={workspaceDetailCardVisible} />
    case 'client':
      return <MatterDrawerClientTab workspaceDetailCardVisible={workspaceDetailCardVisible} />
    case 'clientExt':
      return <MatterDrawerClientExtensionsTab workspaceDetailCardVisible={workspaceDetailCardVisible} />
    case 'related':
      return <MatterDrawerRelatedMattersTab workspaceDetailCardVisible={workspaceDetailCardVisible} />
    default:
      return null
  }
}

WorkspaceDetailsCard.propTypes = {
  isClientWorkspace: PropTypes.bool,
  test: PropTypes.bool,
  sx: PropTypes.object
}

export type WorkspaceDetailsCardProps = {
  isClientWorkspace?: boolean
  test?: boolean
  sx: SxProps
}

type renderTabContentProps = {
  selectedTab: string
  workspaceDetailCardVisible: boolean
}
